import React, { useState } from "react";
import { DatePicker } from "antd";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";
import { selectStyles } from "../../../../components/Select/styles";
import moment from "moment";

const TitulosFilter = ({ onFilterChange, showFilter, abogadosList }) => {
  const [dateValue, setDateValue] = useState({
    desde: "",
    hasta: ""
  });
  const [dateMoment, setDateMoment] = useState({
    desde: "",
    hasta: ""
  });
  const [abogadoAsignado, setAbogadoAsignado] = useState({});
  const [order, setOrder] = useState({ value: "asc", label: "Ascendente" });
  const tiposOrden = [
    { value: "asc", label: "Ascendente" },
    { value: "desc", label: "Descendente" }
  ];
  const { handleSubmit, control, reset } = useForm({});

  const handleClean = () => {
    reset({});
    setDateValue({
      desde: "",
      hasta: ""
    });
    setDateMoment({
      desde: "",
      hasta: ""
    });
    setAbogadoAsignado({});
    setOrder({ value: "asc", label: "Ascendente" });
  };

  const handleSearch = () => {
    onFilterChange({
      startDate: dateValue.desde,
      endDate: dateValue.hasta,
      abogadoCodExt: abogadoAsignado.value ? abogadoAsignado.value.toString() : "",
      order: order.value
    });
  };

  // Función para deshabilitar fechas mayores a hoy
  const disabledDateDesde = (current) => {
    return current && current > moment().endOf("day");
  };

  // Función para deshabilitar fechas en el "Hasta Fecha"
  const disabledDateHasta = (current) => {
    // No permite seleccionar fechas antes de Desde Fecha y después de hoy
    return (
      current &&
      (current < moment(dateMoment.desde) || current > moment().endOf("day"))
    );
  };

  return (
    <div className="filter-container filter-container--gray">
      {showFilter ? (
        <div>
          <Form onSubmit={handleSubmit(handleSearch)}>
            <div>
              <div
                style={{
                  paddingLeft: 15,
                  marginTop: 30,
                  marginBottom: 10,
                  textTransform: "uppercase"
                }}
                className="fw-semibold"
              >
                Datos del convenio:
              </div>
              <Row className="mt-3">
                <Col className="col-dates col-auto" sm={12} md={6}>
                  <Form.Label className="label-date mb-2">Desde</Form.Label>
                  <Controller
                    name="desde"
                    control={control}
                    render={() => {
                      return (
                        <DatePicker
                          className="input-date"
                          placeholder="Seleccione una fecha"
                          format="YYYY-MM-DD"
                          value={dateMoment.desde}
                          disabledDate={disabledDateDesde} // Deshabilitar fechas mayores a hoy
                          onChange={(date, dateString) => {
                            setDateMoment({ ...dateMoment, desde: date });
                            setDateValue({ ...dateValue, desde: dateString });
                          }}
                        />
                      );
                    }}
                  />
                </Col>
                <Col className="col-dates col-auto" sm={12} md={6}>
                  <Form.Label className="label-date mb-2">Hasta</Form.Label>
                  <Controller
                    name="hasta"
                    control={control}
                    render={() => {
                      return (
                        <DatePicker
                          className="input-date"
                          placeholder="Seleccione una fecha"
                          format="YYYY-MM-DD"
                          value={dateMoment.hasta}
                          disabledDate={disabledDateHasta} // Deshabilitar fechas fuera del rango Desde a hoy
                          onChange={(date, dateString) => {
                            setDateMoment({ ...dateMoment, hasta: date });
                            setDateValue({ ...dateValue, hasta: dateString });
                          }}
                          disabled={!dateValue.desde} // Deshabilitar si no hay fecha desde
                        />
                      );
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="col-auto" sm={12} md={6}>
                  <Form.Label className="mb-2">Abogado Asignado</Form.Label>
                  <Controller
                    name="est_retiro"
                    control={control}
                    render={() => {
                      return (
                        <ReactSelect
                          options={abogadosList}
                          onChange={(e) => setAbogadoAsignado(e)}
                          value={abogadoAsignado.label ? abogadoAsignado : ""}
                          styles={selectStyles}
                        />
                      );
                    }}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={6}>
                  <Form.Label className="mb-2">Orden Nº Título</Form.Label>
                  <Controller
                    name="est_retiro"
                    control={control}
                    render={() => {
                      return (
                        <ReactSelect
                          options={tiposOrden}
                          onChange={(e) => setOrder(e)}
                          value={order.label ? order : ""}
                          styles={selectStyles}
                        />
                      );
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Form>
          <Row className="d-flex">
            <div className="p-3">
              <Button
                variant="danger"
                onClick={handleClean}
                className="px-5 py-2"
              >
                Limpiar
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={handleSearch}
                className="mx-3 px-5 py-2"
              >
                Buscar
              </Button>
            </div>
          </Row>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TitulosFilter;